import { render, staticRenderFns } from "./MoveInStorageSelection.vue?vue&type=template&id=3894f4dc&lang=true"
import script from "./MoveInStorageSelection.vue?vue&type=script&lang=js"
export * from "./MoveInStorageSelection.vue?vue&type=script&lang=js"
import style0 from "./MoveInStorageSelection.vue?vue&type=style&index=0&id=3894f4dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports